"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InsuranceCoverageCosts {
    constructor(limit, deductible, premium, serviceFee, serviceFeeBreakdown, tax, taxBreakdown, currency, commission, commissionBreakdown, coverageCostHash) {
        this.limit = limit;
        this.deductible = deductible;
        this.premium = premium;
        this.serviceFee = serviceFee;
        this.serviceFeeBreakdown = serviceFeeBreakdown;
        this.tax = tax;
        this.taxBreakdown = taxBreakdown;
        this.currency = currency;
        this.commission = commission;
        this.commissionBreakdown = commissionBreakdown;
        this.coverageCostHash = coverageCostHash;
    }
}
exports.default = InsuranceCoverageCosts;
//# sourceMappingURL=insuranceCoverageCosts.class.js.map